import React, { useState } from "react";
import "./editProfilDialog.scss";
import { AdminType } from "../../types/UserTypes";
import { requestType } from "../../types/GlobalType";
import { useNavigate } from "react-router-dom";
import { Close, Person2Sharp } from "@mui/icons-material";
import { catchErrorApiCall } from "../../_services/apiUtils";
import toast, { LoaderIcon } from "react-hot-toast";
import { accountService } from "../../_services/accountServices";
import { IconButton } from "@mui/material";
import { API_PERSONNEL } from "../../apiCaller/personnel.Caller";
import ErrorBar from "../../component/errorComp/ErrorBar.tsx";

type Props = {
  data: AdminType | undefined;
  setOpen: React.Dispatch<React.SetStateAction<Boolean>>;
  dispatchReload: () => void;
};
const EditProfilDialog = (props: Props) => {
  const [userData, setUserData] = useState({
    nom: props.data?.nom,
    postnom: props.data?.postnom,
    prenom: props.data?.prenom,
    sexe: props.data?.sexe,
    ville: props.data?.ville,
    commune: props.data?.commune,
    quartier: props.data?.quartier,
    avenue: props.data?.avenue,
    telephone: props.data?.telephone,
  });

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: null,
  });

  const navigate = useNavigate();

  const handleUpdate = async () => {
    if (
      !userData.nom?.toString().length ||
      !userData.postnom?.toString().length ||
      !userData.prenom?.toString().length ||
      !userData.ville?.toString().length ||
      !userData.commune?.toString().length ||
      !userData.quartier?.toString().length ||
      !userData.telephone?.toString().length ||
      !userData.avenue?.toString().length
    ) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez tous les champs",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    try {
      let data = {
        nom: userData.nom,
        postnom: userData.postnom,
        prenom: userData.prenom,
        sexe: userData.sexe,
        ville: userData.ville,
        commune: userData.commune,
        quartier: userData.quartier,
        avenue: userData.avenue,
        telephone: userData.telephone,
      };
      const response = await API_PERSONNEL.PERSONNEL.update(
        props.data?.user_id,
        data,
        token
      );

      if (response.data.status === 200) {
        toast.success("Mis à jour effectuée avec succès", { duration: 3000 });
        // setEleveData({...eleveData})
        props.setOpen(false);
        props.dispatchReload();
      } else {
        setState({ ...state, isLoading: false });

        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  return (
    <>
      <div className="UpdateProfil">
        <div className="dialog_update">
          <div className="headerUpdate">
            <div className="titleUpdate">
              <div className="left_">
                <Person2Sharp className="ico" />
                <span>Modification profil</span>
              </div>
              <IconButton>
                <Close className="ico" onClick={() => props.setOpen(false)} />
              </IconButton>
            </div>
          </div>
          <div className="body_update">
            {state.errorMessage && <ErrorBar title={state.errorMessage} />}
            <div className="item">
              <label>Nom *</label>
              <input
                placeholder="Nom..."
                type="text"
                value={userData.nom}
                onChange={handleChange}
                name="nom"
                // disabled
              />
            </div>
            <div className="item">
              <label>Postnom *</label>
              <input
                placeholder="Post-nom..."
                type="text"
                value={userData.postnom}
                onChange={handleChange}
                name="postnom"
                // disabled
              />
            </div>
            <div className="item">
              <label>Prénom *</label>
              <input
                placeholder="Prénon..."
                type="text"
                value={userData.prenom}
                onChange={handleChange}
                name="prenom"
                // disabled
              />
            </div>
            {/* <input placeholder="Email..." type="text" value={props.data?.email} /> */}

            <div className="item">
              <label>Téléphone *</label>
              <input
                placeholder="Téléphone..."
                type="text"
                value={userData.telephone}
                onChange={handleChange}
                name="telephone"
              />
            </div>
            {/* <input placeholder="Pays..." type="text" value={props.data?.pays} /> */}
            <div className="item">
              <label>Ville *</label>
              <input
                placeholder="Ville..."
                type="text"
                value={userData.ville}
                onChange={handleChange}
                name="ville"
              />
            </div>
            <div className="item">
              <label>Commune *</label>
              <input
                placeholder="Commune..."
                type="text"
                value={userData.commune}
                onChange={handleChange}
                name="commune"
              />
            </div>

            <div className="item">
              <label>Quartier *</label>
              <input
                placeholder="Quartier..."
                type="text"
                value={userData.quartier}
                onChange={handleChange}
                name="quartier"
              />
            </div>

            <div className="item">
              <label>Avenue *</label>
              <input
                placeholder="Avenue..."
                type="text"
                value={userData.avenue}
                onChange={handleChange}
                name="avenue"
              />
            </div>
          </div>
          <div className="errorMsg">
            {state.errorMessage && <span>{state.errorMessage}</span>}
          </div>
          <div className="btn">
            <button onClick={() => props.setOpen(false)}>Annuler</button>
            {state.isLoading ? (
              <button>
                <LoaderIcon />
              </button>
            ) : (
              <button onClick={handleUpdate}>Modifier</button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditProfilDialog;
